import React from 'react';
import * as Icons from 'lucide-react';
import { features } from '../mock/data';
import { useReveal } from '../hooks/useReveal';

function FeatureCard({ f, idx }) {
  const Icon = Icons[f.icon] || Icons.Sparkles;
  const { ref, inView } = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${(idx % 3) * 100}ms` }}
      className={`reveal ${inView ? 'in-view' : ''} lift group rounded-2xl bg-white border border-[var(--pca-border)] p-6 md:p-7`}
    >
      <div className="w-12 h-12 rounded-xl bg-[var(--pca-blue-soft)] flex items-center justify-center text-[var(--pca-blue)] group-hover:bg-[var(--pca-navy)] group-hover:text-white transition-colors">
        <Icon size={22} />
      </div>
      <h3 className="mt-5 text-[18px] font-bold text-[#0B2E6E]">{f.title}</h3>
      <p className="mt-2 text-slate-600 text-[15px] leading-relaxed">{f.desc}</p>
    </div>
  );
}

export default function Features() {
  const { ref, inView } = useReveal();
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="container-x">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} text-center max-w-2xl mx-auto`}>
          <span className="section-eyebrow">WHAT WE OFFER</span>
          <h2 className="section-title mt-4 text-[34px] md:text-[44px] leading-tight">Everything you need to succeed</h2>
          <p className="mt-4 text-slate-600 text-[16px]">
            World-class infrastructure, expert faculty, and industry-ready curriculum designed to shape future pharmacists.
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f, i) => <FeatureCard key={f.title} f={f} idx={i} />)}
        </div>
      </div>
    </section>
  );
}
